import { markCurrentPosition, removeCurrentPosition } from '../main-container/markCurrentPosition'; // Import the functions

export const handleWhereAmI = (map, long, lat, rotation, pitch, bearing, whereAmILevel, whereAmIBuilding, zoom=20.8, scale=150.091301692798277e-8) => {
  return () => {
    if (map) {
      markCurrentPosition(map, long, lat, rotation, true, pitch, bearing, whereAmIBuilding, whereAmILevel, whereAmIBuilding, whereAmILevel, zoom, scale);
    }
  };
};